import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({ standalone:false,
  selector: 'app-qb-disconnect-dialog',
  templateUrl: './qb-disconnect-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./qb-disconnect-dialog.component.scss']
})
export class QbDisconnectDialogComponent {
  title: string= "Title";
  message: string = "Are you sure?";
  confirmButtonText = "Yes";
  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<QbDisconnectDialogComponent>) {
    if(data){
      this.title=data.title;
      this.message=data.message || this.message;
      if(data.buttonText){
        this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
      }
    }
   }

   onConfirmClick(): void {
    this.dialogRef.close(true);
  }
}
